import authHook from './routerAuthHook'
import bodyClassHook from './bodyClassHook'
import { VueRouter } from 'vue-router/types/router'

export default (router: VueRouter) => {
  router.beforeEach(authHook())
  router.beforeEach(bodyClassHook())
}
